// ----------------------------------------------------------------------
// <copyright file="Izenda.RelationshipDetailValidator.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Relationship Detail Validator
 */
!(function () {
  var validate = require("validate.js");

  function RelationshipDetailValidator() {
    var setupValidate = function () {
      validate.validators.presence.options = { message: "Required" };
    };

    this.constraints = {
      joinType: { presence: true },
      joinConnectionId: { presence: true },
      joinQuerySourceId: { presence: true },
      joinFieldId: { presence: true },
      foreignConnectionId: { presence: true },
      foreignQuerySourceId: { presence: true },
      foreignFieldId: { presence: true }
    };

    setupValidate();
  }

  /**
   * Validate a relationship detail
   */
  RelationshipDetailValidator.prototype.validate = function (obj,isCrossType,options) {
    options = options || { fullMessages: false };

    this.constraints.joinFieldId.presence = !isCrossType;
    this.constraints.foreignFieldId.presence = !isCrossType;

    return validate(obj, this.constraints, options) || {};
  };

  module.exports = RelationshipDetailValidator;
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/Relationship/Izenda.RelationshipDetailValidator.js